// material-ui
import { Theme, alpha } from '@mui/material/styles';
// types
import { CustomGradientProps } from 'types/theme';
import { ThemeMode } from 'config';

// ==============================|| CUSTOM GRADIENTS (ElevenLabs-inspired) ||============================== //
/** Fundo e superfícies no estilo elevenlabs.io/app/home: claro quase sólido, sem gradientes pesados. */
export default function CustomGradients(theme: Theme): CustomGradientProps {
  const isDark = theme.palette.mode === ThemeMode.DARK;

  // Light: branco puro; superfícies grandes em cinza neutro (#F2F2F2)
  const appLight = `linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%)`;

  const paperLight = `
    linear-gradient(
      180deg,
      #F2F2F2 0%,
      ${alpha('#EEEEEE', 0.98)} 100%
    )`;

  const toolbarLight = `linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%)`;

  // Dark: zinc neutro (sem verde marca antigo)
  const appDark = `
    linear-gradient(
      165deg,
      ${alpha('#09090B', 0.99)} 0%,
      ${alpha('#18181B', 0.97)} 40%,
      ${alpha('#27272A', 0.42)} 100%
    )`;

  const paperDark = `
    linear-gradient(
      170deg,
      ${alpha('#18181B', 0.72)} 0%,
      ${alpha('#27272A', 0.38)} 100%
    )`;

  const toolbarDark = `
    linear-gradient(
      170deg,
      ${alpha('#09090B', 0.94)} 0%,
      ${alpha('#18181B', 0.82)} 55%,
      ${alpha('#3F3F46', 0.28)} 100%
    )`;

  return {
    appBg: isDark ? appDark : appLight,
    paperBg: isDark ? paperDark : paperLight,
    toolbarBg: isDark ? toolbarDark : toolbarLight
  };
}
